module.exports = __webpack_public_path__ + "img/rjkfyyhy.2d94596d.png";